module.exports = __webpack_public_path__ + "static/media/pending-dispatch_viejo.7a9aeca0.svg";